import Box from '@mui/material/Box';

export default function OnboardingContentWrapper({ children }) {
  return (
    <Box sx={{ maxWidth: 500, margin: '0 auto' }}>
      {children}
    </Box>
  );
}
